import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()(() => {
    return {
        header: {
            display: 'flex',
            justifyContent: 'space-between',
        },
        tableContentWrapper: {
            padding: 0,
            borderRadius: 0,
            width: '100%',
            boxSizing: 'border-box',
            border: 'none',
            position: 'static',
        },
        tableContent: {
            boxShadow: 'none !important',
        },
        cardContent: {
            paddingRight: 0,
            paddingLeft: 0,
        },
        icon: {
            cursor: 'pointer',
        },
        iconWrapper: {
            display: 'flex',
        },
    }
})

export default useStyles
